// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".O2NCX3pelTmVHMEJzuh5{height:100%}.O2NCX3pelTmVHMEJzuh5 input:-webkit-autofill{-webkit-box-shadow:0 0 0px 1000px #fff inset}.XPsX6g9srqbkkTBN23k7{display:flex;flex-direction:column;justify-content:flex-start;align-items:stretch;row-gap:10px}@media(min-width: 768px){.XPsX6g9srqbkkTBN23k7>*{max-width:424px}}.PlnMelJcI51iFMyHWyXa{margin-top:10px;margin-bottom:28px;color:#5b6473}.PYQeMhJ2jrvOAsw4gAm3{line-height:1.2;font-size:14px}.Fk9TmHUajYdV7x8PJ3Z8{color:#1874fd;text-decoration:underline}.p1VDPzWHE91X0gJ_8tmY{margin-top:14px;color:#f56565;font-size:14px}.i8DjeWpTp82ut9tap5aZ{width:100%;margin-top:20px;max-width:100%}.f4O6pCFaJnnMpkOFgvh_{width:100%}@media(min-width: 768px){.f4O6pCFaJnnMpkOFgvh_{width:auto;padding-left:52px !important;padding-right:52px !important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": "O2NCX3pelTmVHMEJzuh5",
	"formContainer": "XPsX6g9srqbkkTBN23k7",
	"formGender": "PlnMelJcI51iFMyHWyXa",
	"formPolicyCheckbox": "PYQeMhJ2jrvOAsw4gAm3",
	"formPolicyLink": "Fk9TmHUajYdV7x8PJ3Z8",
	"formWarning": "p1VDPzWHE91X0gJ_8tmY",
	"formConfirm": "i8DjeWpTp82ut9tap5aZ",
	"formConfirmBtn": "f4O6pCFaJnnMpkOFgvh_"
};
export default ___CSS_LOADER_EXPORT___;
